// corresponding text for each wave value

const waveDescription = {
    flat: "Nice and flat",
    swell: "There was some swell",
    bigWaves: "There was big waves!"
}

export default waveDescription